const dev = {
  IDENTITY_ENDPOINT_URL: 'https://identity.pscanary.com',
  VPS_ENDPOINT_URL: 'https://vps.pscanary.com',
  IPS_ENDPOINT_URL: 'https://ips.pscanary.com',
  BILLING_ENDPOINT_URL: 'https://billing.pscanary.com',
  HELPDESK_ENDPOINT_URL: 'https://helpdesk.pscanary.com',
  WEB_NOTIFY_ENDPOINT_URL: 'https://web-notify.pscanary.com/sse',
  DOMAIN_ENDPOINT_URL: 'https://domain.pscanary.com',
  PROXY_ENDPOINT_URL: 'https://proxy.pscanary.com',
  DNS_ENDPOINT_URL: 'https://dns.pscanary.com',
  EMAIL_ENDPOINT_URL: 'https://email.pscanary.com',
  AUTOMATION_ENDPOINT_URL: 'https://automation.pscanary.com',
  PAG_BANK_PUBLIC_KEY:
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr+ZqgD892U9/HXsa7XqBZUayPquAfh9xx4iwUbTSUAvTlmiXFQNTp0Bvt/5vK2FhMj39qSv1zi2OuBjvW38q1E374nzx6NNBL5JosV0+SDINTlCG0cmigHuBOyWzYmjgca+mtQu4WczCaApNaSuVqgb8u7Bd9GCOL4YJotvV5+81frlSwQXralhwRzGhj/A57CGPgGKiuPT+AOGmykIGEZsSD9RKkyoKIoc0OS8CPIzdBOtTQCIwrLn2FxI83Clcg55W8gkFSOS6rWNbG5qFZWMll6yl02HtunalHmUlRUL66YeGXdMDC2PuRcmZbGO5a/2tbVppW6mfSWG3NPRpgwIDAQAB',
  PIXEL_ID: '1979867796103216',
  GOOGLE_TAG_MANAGER_ID: 'GTM-TQGKV8TW',
}

const prod = {
  IDENTITY_ENDPOINT_URL: 'https://identity.onepanel.com.br',
  VPS_ENDPOINT_URL: 'https://vps.onepanel.com.br',
  IPS_ENDPOINT_URL: 'https://ips.pscanary.com',
  BILLING_ENDPOINT_URL: 'https://billing.onepanel.com.br',
  HELPDESK_ENDPOINT_URL: 'https://helpdesk.onepanel.com.br',
  WEB_NOTIFY_ENDPOINT_URL: 'https://dev-web-notify.toquinha.online/sse',
  DOMAIN_ENDPOINT_URL: 'https://domain.onepanel.com.br',
  PROXY_ENDPOINT_URL: 'https://proxy.onepanel.com.br',
  DNS_ENDPOINT_URL: 'https://dns.onepanel.com.br',
  EMAIL_ENDPOINT_URL: 'https://email.onepanel.com.br',
  AUTOMATION_ENDPOINT_URL: 'https://automation.onepanel.com.br',
  PAG_BANK_PUBLIC_KEY:
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxuY1gAOXb8pCdhZG5YvAM1Z/Av7kU5stVWZvstKKxWdfKXJxpK6/ClPizVU2ZswSrAfcHyO4fvFyNZ54hAq0AgNA1lRax+mANAWH+NKGVrxyZkO5UjTqFKqBOfQF2X739y2y7CKOKBu3lqh+EplgBmu8yf+oMR92fqmAoYbV+IduCUmKQYrINFJS+sKSTjYJdVP5n3euRIq08MfG4QpUBoj97UitBZKt01EEGVU+0GaRt+CELJyJTel6uZT/cX/nTOeGTwv96J0XVR5UhOytJH6KALg6MQnLGYKMLi9cx+/3EkgqBDC5MlBUspXO5mksefT6XTTL0aOrEpT0YXG23QIDAQAB',
  PIXEL_ID: '1979867796103216',
  GOOGLE_TAG_MANAGER_ID: 'GTM-TQGKV8TW',
}

const test = {
  IDENTITY_ENDPOINT_URL: 'https://dev-identity.toquinha.online',
  VPS_ENDPOINT_URL: 'https://dev-vps.toquinha.online',
  IPS_ENDPOINT_URL: 'https://ips.pscanary.com',
  BILLING_ENDPOINT_URL: 'https://dev-billing.toquinha.online',
  HELPDESK_ENDPOINT_URL: 'https://dev-helpdesk.toquinha.online',
  DOMAIN_ENDPOINT_URL: 'https://dev-domain.toquinha.online',
  PROXY_ENDPOINT_URL: 'https://dev-proxy.toquinha.online',
  DNS_ENDPOINT_URL: 'https://dev-dns.toquinha.online',
  EMAIL_ENDPOINT_URL: 'https://dev-email.toquinha.online',
  AUTOMATION_ENDPOINT_URL: 'https://dev-automation.toquinha.online',
  PAG_BANK_PUBLIC_KEY:
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAr+ZqgD892U9/HXsa7XqBZUayPquAfh9xx4iwUbTSUAvTlmiXFQNTp0Bvt/5vK2FhMj39qSv1zi2OuBjvW38q1E374nzx6NNBL5JosV0+SDINTlCG0cmigHuBOyWzYmjgca+mtQu4WczCaApNaSuVqgb8u7Bd9GCOL4YJotvV5+81frlSwQXralhwRzGhj/A57CGPgGKiuPT+AOGmykIGEZsSD9RKkyoKIoc0OS8CPIzdBOtTQCIwrLn2FxI83Clcg55W8gkFSOS6rWNbG5qFZWMll6yl02HtunalHmUlRUL66YeGXdMDC2PuRcmZbGO5a/2tbVppW6mfSWG3NPRpgwIDAQAB',
  PIXEL_ID: '1979867796103216',
  GOOGLE_TAG_MANAGER_ID: 'GTM-TQGKV8TW',
}

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case 'development':
      return dev
    case 'production':
      return prod
    case 'test':
      return test
    default:
      break
  }
}

export const env = getEnv()
